import Link from 'gatsby-link'
import React from 'react'
import Container from './basic/Container'
import Footer from './Footer'
import Layout from '../layouts'
import { getHome } from "../utils"
import auth from '../utils/auth'

import Grid from '@material-ui/core/Grid'

import styles from './MainLayout.module.scss'

const MainLayout: React.FC = ({ children }) => {
  return (<Layout>
    <header className={styles.header}>
      <Container>
        <Grid container={true}>
          <Grid item xs={6}>
            <Link to={getHome()}><img src="/style/cotsucotsu-logo.png" alt="Home" /></Link>
          </Grid>
          <Grid item xs={6} className={styles.right}>
            <Link to={'/meinbereich/'}>{ auth.isAuthenticated() ? 'Mein Bereich' : 'Anmelden' }</Link>
          </Grid>
        </Grid>
      </Container>
    </header>
    <main className={styles.main}>
      {children}
    </main>
    <Footer />
  </Layout>);
}

export default MainLayout
